import i18next from 'i18next';
import i18CustomParams from 'new_design/common/i18_custom';

export default class DescriptionRight extends React.Component {
  constructor(props) {
    super(props);
    this.seo_path_with_params = this.seo_path_with_params.bind(this);
    this.button = this.button.bind(this);
    this.cashback = this.cashback.bind(this);
    this.pluralize_days = this.pluralize_days.bind(this);
    this.pluralize_guests = this.pluralize_guests.bind(this);
    this.rating_block = this.rating_block.bind(this);
    this.price_bonus_block = this.price_bonus_block.bind(this);

    i18next.init(i18CustomParams(), function (err, t) {});
  }

  seo_path_with_params() {
    let seo_path_with_params = this.props.seo_path;
    if (this.props.filter_params.url_str) seo_path_with_params += `?${this.props.filter_params.url_str}`;
    return seo_path_with_params;
  }

  cashback() {
    if (!this.props.has_cashback) return null;
    return (
      <div className={'cashback-label'}>
        <span>Кешбэк 10%</span>
        <span>·</span>
        <div className={'cashback-label_icon'}></div>
      </div>
    );
  }

  button() {
    return (
      <a
        href={this.seo_path_with_params()}
        rel={this.props.is_nofollow ? 'nofollow' : null}
        target='_blank'
        className='card__price-btn btn btn_color btn_block camp_link'
      >
        Подробнее
      </a>
    );
  }

  pluralize_days(num) {
    switch (num) {
      case 1:
        return 'ночь';
      case 2:
      case 3:
      case 4:
        return 'ночи';
      default:
        return 'ночей';
    }
  }

  pluralize_guests(num) {
    switch (num) {
      case 1:
        return 'человека';
      default:
        return 'человек';
    }
  }

  rating_block() {
    if (this.props.score > 0) {
      return (
        <a
          href={`${this.seo_path_with_params()}#reviews`}
          target='_blank'
          className='card__rating camp_link'
          rel={this.props.is_nofollow ? 'nofollow' : null}
        >
          <div className='card__rating-numb'>
            <span className='text_black'>{this.props.score.toFixed(1)}</span>
            <span className='text_gray'>/10</span>
          </div>
          <div
            className={`card__rating-name card__rating-name_${this.props.rating_style} rating-label_${this.props.rating_style}`}
          ></div>
          <div className='card__rating-review text_f14 text_gray'>
            <div className='card__review-count'>
              <i className='far fa-comment'></i> {this.props.reviews_count_string}
            </div>
          </div>
        </a>
      );
    }
    return undefined;
  }

  price_bonus_block() {
    const {
      bonuses,
      min_price,
      delta_days,
      count_guests,
      filter_params: { project },
      campsLoaded,
      show_all_camps,
    } = this.props;

    const minPriceBlock = (
      <span
        className={`${this.props.selectedTariff?.special_offer_discount ? 'text_red' : 'text_black'} price rub-icon_black`}
      >
        {min_price}
      </span>
    );

    if (!bonuses) {
      if (show_all_camps) {
        if (campsLoaded && !min_price && delta_days) {
          return <span className='text_black price'>Мест нет</span>;
        } else {
          return minPriceBlock;
        }
      } else {
        return minPriceBlock;
      }
    }

    const validSearch = delta_days && count_guests;
    const bonusKey = validSearch ? 'bonus' : 'bonus_from';
    const bonuses_string = `${i18next.t(bonusKey, { count: bonuses })}`;
    let bonuses_percent = (parseInt(bonuses) / parseInt(min_price.replace(/\D/g, ''))) * 100;
    bonuses_percent = Math.round(bonuses_percent * 10) / 10;
    return (
      <div className='price-with-bonuses'>
        <div className='price_bonuses under packet_description tooltip'>
          <span className='price-with-bonuses__bonuses'>{bonuses_string}</span>
          <span className='tooltiptext auto wide filter'>
            <b>Бонусная программа {project}</b>
            {bonuses} {i18next.t('full_bonus', { count: bonuses })} ({bonuses_percent}%) будут начислены вам в течение 3
            дней после выезда из объекта размещения. Используйте баллы при бронировании жилья на {project}. Оплачивайте
            до 20% стоимости бронирования. 1 бонус = 1 рубль
          </span>
        </div>
        <span
          className={`${this.props.selectedTariff?.special_offer_discount ? 'text_red' : 'text_black'} price rub-icon_black`}
        >
          {min_price}
        </span>
      </div>
    );
  }

  render() {
    const {
      props: { discount, delta_days, count_guests, children_ages, complex_placement },
    } = this;

    const displayTariff = this.props.selectedTariff
    let all_guest_count
    if (complex_placement != null && (count_guests + children_ages.length) > complex_placement.total_guests) {
      all_guest_count = complex_placement.total_guests;
    } else if (displayTariff != null && (count_guests + children_ages.length) > (displayTariff?.seats + displayTariff?.seats_additional + displayTariff?.child_count_no_seats)) {
      all_guest_count = displayTariff?.seats + displayTariff?.seats_additional + displayTariff?.child_count_no_seats
    } else {
      all_guest_count = count_guests + children_ages.length
    }

    const price_line =
      delta_days && count_guests ? (
        <div>
          {delta_days} {this.pluralize_days(delta_days)} для {all_guest_count}{' '}
          {this.pluralize_guests(all_guest_count)}
        </div>
      ) : undefined;

    const outdated_price =
      this.props.show_outdated_price && this.props.allCampsLoaded && this.props.min_price ? (
        <div>
          <span style={{ fontSize: 12, color: '#e01b00', fontFamily: 'Roboto, sans-serif' }}>
            Цена требует уточнения
          </span>
        </div>
      ) : (
        ''
      );

    return (
      <div className='card__desc-right'>
        {this.rating_block()}
        <div className='card__price'>
          <a
            href={`${this.seo_path_with_params()}#apartments`}
            target='_blank'
            className={`price-box camp_link ${this.props.show_all_camps ? 'favorite_price-box' : ''}`}
            rel={this.props.is_nofollow ? 'nofollow' : null}
          >
            <span className='text_gray card__price-people text_f14'>{price_line}</span>
            {discount ? (
              <div>
                <div className='price_discount'>
                  <span className='price_discount-value'>{this.props.min_price_without_discount}</span>
                  <span className='price_discount-percent'>-{discount}%</span>
                </div>
                {this.price_bonus_block()}
                {this.props.selectedTariff?.special_offer_discount && (
                  <div data-daily-offer-timer data-timer-variant='compact'></div>
                )}
              </div>
            ) : (
              this.price_bonus_block()
            )}
            {outdated_price}
          </a>
          {this.cashback()}
          {this.button()}
        </div>
      </div>
    );
  }
}
